module.exports = __webpack_public_path__ + "static/img/6.151aef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/6.jpg
// module id = UnDk
// module chunks = 0